import React, { useState, useEffect } from "react";
import "./Navigation.css";

function Navigation() {
  const [activeSection, setActiveSection] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const sections = [
    { id: "AboutMe", label: "Обо мне" },
    { id: "ServicesContent", label: "Услуги" },
    { id: "Work", label: "Галерея" },
    { id: "Questions", label: "Вопросы" },
    { id: "Reviews", label: "Отзывы" },
    { id: "Footer", label: "Контакты" },
  ];

  // Проверка на мобильное устройство
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Отслеживание скролла для изменения стиля меню
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Отслеживание активной секции
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions,
    );

    sections.forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        observer.observe(element);
      }
    });

    return () => observer.disconnect();
  }, []);

  // Прокрутка к секции
  const scrollToSection = (id, e) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = isScrolled ? 100 : 120;
      window.scrollTo({
        top: element.offsetTop - offset,
        behavior: "smooth",
      });
      setActiveSection(id);

      // Закрываем мобильное меню при клике на ссылку
      if (isMobile) {
        setIsMobileMenuOpen(false);
      }

      // Обновление URL без перезагрузки
      window.history.pushState(null, null, `#${id}`);
    }
  };

  // Обработка хэшей при загрузке
  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, []);

  // Отключение скролла при открытом мобильном меню
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobileMenuOpen]);

  // Закрытие меню при клике вне его области
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isMobileMenuOpen &&
        !e.target.closest(".mobile-menu") &&
        !e.target.closest(".burger-btn")
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobileMenuOpen]);

  return (
    <>
      {/* Кнопка бургер-меню для мобильных */}
      {isMobile && (
        <button
          className={`burger-btn ${isMobileMenuOpen ? "active" : ""}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={isMobileMenuOpen ? "Закрыть меню" : "Открыть меню"}
          aria-expanded={isMobileMenuOpen}
        >
          <span className="burger-line"></span>
          <span className="burger-line"></span>
          <span className="burger-line"></span>
        </button>
      )}

      {/* Основное меню для десктопа */}
      <nav className={`menu-nav ${isScrolled ? "scrolled" : ""}`}>
        <ul className="menu-ul">
          {sections.map((section) => (
            <li
              key={section.id}
              className={`li ${activeSection === section.id ? "current" : ""}`}
            >
              <a
                className={`a ${activeSection === section.id ? "active" : ""}`}
                href={`#${section.id}`}
                onClick={(e) => scrollToSection(section.id, e)}
                aria-label={`Перейти к разделу ${section.label}`}
              >
                {section.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      {/* Мобильное меню */}
      {isMobile && (
        <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
          <ul className="menu-ul">
            {sections.map((section) => (
              <li
                key={section.id}
                className={`li ${activeSection === section.id ? "current" : ""}`}
              >
                <a
                  className={`a ${activeSection === section.id ? "active" : ""}`}
                  href={`#${section.id}`}
                  onClick={(e) => scrollToSection(section.id, e)}
                  aria-label={`Перейти к разделу ${section.label}`}
                >
                  {section.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}

export default Navigation;
